export const Select = ({ className }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.9974 4.66667C5.26102 4.66667 4.66406 4.06971 4.66406 3.33333C4.66406 2.59695 5.26102 2 5.9974 2C6.73378 2 7.33073 2.59695 7.33073 3.33333C7.33073 4.06971 6.73378 4.66667 5.9974 4.66667Z"
        fill="#B9BDC4"
      />
      <path
        d="M5.9974 9.33333C5.26102 9.33333 4.66406 8.73638 4.66406 8C4.66406 7.26362 5.26102 6.66667 5.9974 6.66667C6.73378 6.66667 7.33073 7.26362 7.33073 8C7.33073 8.73638 6.73378 9.33333 5.9974 9.33333Z"
        fill="#B9BDC4"
      />
      <path
        d="M5.9974 14C5.26102 14 4.66406 13.403 4.66406 12.6667C4.66406 11.9303 5.26102 11.3333 5.9974 11.3333C6.73378 11.3333 7.33073 11.9303 7.33073 12.6667C7.33073 13.403 6.73378 14 5.9974 14Z"
        fill="#B9BDC4"
      />
      <path
        d="M9.9974 4.66667C9.26102 4.66667 8.66406 4.06971 8.66406 3.33333C8.66406 2.59695 9.26102 2 9.9974 2C10.7338 2 11.3307 2.59695 11.3307 3.33333C11.3307 4.06971 10.7338 4.66667 9.9974 4.66667Z"
        fill="#B9BDC4"
      />
      <path
        d="M9.9974 9.33333C9.26102 9.33333 8.66406 8.73638 8.66406 8C8.66406 7.26362 9.26102 6.66667 9.9974 6.66667C10.7338 6.66667 11.3307 7.26362 11.3307 8C11.3307 8.73638 10.7338 9.33333 9.9974 9.33333Z"
        fill="#B9BDC4"
      />
      <path
        d="M9.9974 14C9.26102 14 8.66406 13.403 8.66406 12.6667C8.66406 11.9303 9.26102 11.3333 9.9974 11.3333C10.7338 11.3333 11.3307 11.9303 11.3307 12.6667C11.3307 13.403 10.7338 14 9.9974 14Z"
        fill="#B9BDC4"
      />
    </svg>
  );
};
